module.exports = "<ul class=\"pagination\" ng-if=\"$ctrl.buttons.length > 1\">\n    <li ng-repeat=\"pageButton in $ctrl.buttons\"\n        ng-class=\"{'is-active': $ctrl.paginationCursor.selectedPageIndex === pageButton.pageIndex }\">\n        <a ng-click=\"pageButton.callback()\">{{ pageButton.label }} </a>\n    </li>\n</ul>\n\n\n<!--  ng-class=\"{'is-active': page.number === $ctrl.currentPage, 'disabled': page.action === undefined}\"   -->\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/components/pagination-remote/paginationRemote.html
 ** module id = 347
 ** module chunks = 0
 **/